<template>
  <div id="contenedor-editar-informe-respuesta-detalle">
    <v-form
      v-model="formularioValido"
      ref="editarAuditoriaInformeRepuestaDetalle">
      <v-card>
        <v-card-title>
          Editar Detalle de la Respuesta
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mx-2"></v-divider>

        <v-card-subtitle>
          <v-row>
            <v-col cols="3">
              Observación
            </v-col>
            <v-col cols="9">
              <span
                  class="font-weight-bold azul2--text"
                  style="padding-left: 10px; display: block;"
                  v-if="respuestaDetalleEditar.observacionDetalle.auditoriaObservacion.numero">
                  {{respuestaDetalleEditar.observacionDetalle.auditoriaObservacion.numero}}</span>
            </v-col>
          </v-row>
          <div>
            <span
            class="text-caption font-weight-light"
            style="padding-left: 10px; display: block;"
            v-if="respuestaDetalleEditar.observacionDetalle.auditoriaObservacion.descripcion">
            <cortar-texto
              :texto="respuestaDetalleEditar.observacionDetalle.auditoriaObservacion ?
              respuestaDetalleEditar.observacionDetalle.auditoriaObservacion.descripcion : ''"
              >
            </cortar-texto>
            </span>
          </div>
          <v-row>
            <v-col cols="3">
              Contrato
            </v-col>
            <v-col cols="9">
              <span
                  class="font-weight-bold naranja--text"
                  style="padding-left: 10px; display: block;"
                  v-if="respuestaDetalleEditar.observacionDetalle.contrato.numero">
                  {{respuestaDetalleEditar.observacionDetalle.contrato.numero}}</span>
            </v-col>
          </v-row>
          <div>
            <span
            class="text-caption font-weight-light"
            style="padding-left: 10px; display: block;"
            v-if="respuestaDetalleEditar.observacionDetalle">
            <cortar-texto
              :texto="respuestaDetalleEditar.observacionDetalle ?
              respuestaDetalleEditar.observacionDetalle.texto : ''"
              :cantidad-caracteres="45">
            </cortar-texto>
            </span>
          </div>
        </v-card-subtitle>
        <v-card-text>
          <v-switch
            :disabled="getEstatusSolventada()"
            v-model="respuestaDetalle.esRespuestaParcial"
            label="¿Es Respuesta Parcial?">
          </v-switch>
          <TextArea
            :disabled="getEstatusSolventada()"
            v-model="respuestaDetalle.comentarios"
            label="Comentarios"
            rows="3">
          </TextArea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
            </custom-button>
          <custom-button
            @click="botonActualizarAuditoriaInformeRespuestaDetalle"
            tipo="formAceptar"
            label="Guardar"
            :disabled="!formularioValido || enviandoFormulario || getEstatusSolventada()"
            :loading="enviandoFormulario"
            >
            </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
    <!-- Propuesta de actualización de Estatus de Observación -->
    <v-dialog
        v-if="!$apollo.loading && mostrarPropuestaActualizacionEstatus"
        v-model="mostrarPropuestaActualizacionEstatus"
        width="500px"
        persistent
        >
        <EvaluacionRespuestas
        v-on:cerrarVentanaEvaluacionRespuestas="cerrarVentanaEvaluacionRespuestas"
        v-on:botonActualizaEstatus="botonActualizaEstatus"
        :mensaje="getMensaje()"
       >
        </EvaluacionRespuestas>
    </v-dialog>
  </div>
</template>

<script>
import TextArea from '@/components/inputs/sinColumnas/TextArea.vue';
import CustomButton from '@/components/buttons/Button.vue';
import CortarTexto from '@/components/CortarTextos.vue';
import mixRespuestas from '../mixRespuestas';
import EvaluacionRespuestas from '@/components/administracion/auditorias/respuestas/detalles/EvaluacionRespuestas.vue';
import mixEvaluacionRespuestas from './mixEvaluacionRepuestas';

export default {
  name: 'EditarInformeRespuestaDetalle',
  mixins: [mixRespuestas, mixEvaluacionRespuestas],
  props: {
    respuestaDetalleEditar: {
      type: Object,
      required: true,
    },
    informe: {
      type: Object,
      required: true,
    },
  },
  components: {
    TextArea,
    CortarTexto,
    CustomButton,
    EvaluacionRespuestas,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      respuestaDetalle: {
        esRespuestaParcial: this.respuestaDetalleEditar.esRespuestaParcial,
        comentarios: this.respuestaDetalleEditar.comentarios,
      },
      descripcionEstatusActualizar: '',
      mostrarPropuestaActualizacionEstatus: false,
      observacionEstatus: this.respuestaDetalleEditar.observacionDetalle.auditoriaObservacion.estatus || '',
    };
  },
  methods: {
    cerrarVentanaEvaluacionRespuestas() {
      this.mostrarPropuestaActualizacionEstatus = !this.mostrarPropuestaActualizacionEstatus;
      this.cerrar();
    },
    async botonActualizaEstatus() {
      this.mostrarPropuestaActualizacionEstatus = !this.mostrarPropuestaActualizacionEstatus;
      await this.actualizarEstatusObservacion(
        [{
          idObservacion: this.respuestaDetalleEditar.observacionDetalle.auditoriaObservacion.id,
        }],
        this.descripcionEstatusActualizar,
      );
      this.cerrar();
    },
    async botonActualizarAuditoriaInformeRespuestaDetalle() {
      await this.mixEditarRespuestaDetalle();
      if (this.getMensaje() !== '') {
        this.mostrarPropuestaActualizacionEstatus = true;
      } else {
        this.cerrar();
      }
    },
    limpiarFormularioRespuestas() {
      this.$refs.editarAuditoriaInformeRepuestaDetalle.reset();
    },
    cerrar() {
      this.limpiarFormularioRespuestas();
      this.$emit('cerrar');
    },
    getMensaje() {
      const detalleEvaluarRespuestas = (this.getEvaluarRespuestas()
        .filter((r) => r.idObservacion
        === this.respuestaDetalleEditar.observacionDetalle.idAuditoriaObservacion))[0];
      const noEnviadas = detalleEvaluarRespuestas.noEnviadas.length;
      const { estatus } = detalleEvaluarRespuestas;
      const { enviadasCompletas } = detalleEvaluarRespuestas;
      // console.log('editar--> ', detalleEvaluarRespuestas);
      if (estatus === 'PENDIENTE' && noEnviadas === 0 && enviadasCompletas === false) {
        this.descripcionEstatusActualizar = 'RESPUESTA ENVIADA PARCIAL';
        return `Se han completado parcialmente los desgloses de la observación,
          desea cambiar el estatus de PENDIENTE a RESPUESTA ENVIADA PARCIAL`;
      }
      if (estatus === 'PENDIENTE' && noEnviadas === 0 && enviadasCompletas === true) {
        this.descripcionEstatusActualizar = 'RESPUESTA ENVIADA COMPLETA';
        return `Se han completado los desgloses de la observación,
          desea cambiar el estatus de PENDIENTE a RESPUESTA ENVIADA COMPLETA`;
      }
      if (estatus === 'POR RESPONDER' && noEnviadas === 0 && enviadasCompletas === false) {
        this.descripcionEstatusActualizar = 'RESPUESTA ENVIADA PARCIAL';
        return `Se han completado parcialmente los desgloses de la observación,
          desea cambiar el estatus de POR RESPONDER a RESPUESTA ENVIADA PARCIAL`;
      }
      if (estatus === 'RESPUESTA ENVIADA PARCIAL' && (noEnviadas === 0 && enviadasCompletas === true)) {
        this.descripcionEstatusActualizar = 'RESPUESTA ENVIADA COMPLETA';
        return `Se han completado todos los desgloses de la observación,
          desea cambiar el estatus de RESPUESTA ENVIADA PARCIAL 
          a RESPUESTA ENVIADA COMPLETA`;
      }
      if (estatus === 'RESPUESTA ENVIADA COMPLETA' && (noEnviadas > 0 || enviadasCompletas === false)) {
        this.descripcionEstatusActualizar = 'RESPUESTA ENVIADA PARCIAL';
        return `Quedan Desgloses de la observación por responder de manera
      completa al Ente, desea cambiar su estatus 
      de RESPUESTA ENVIADA COMPLETA a RESPUESTA ENVIADA PARCIAL`;
      }
      return '';
    },
    getEstatusSolventada() {
      if (!this.observacionEstatus || this.observacionEstatus === ''
      || this.observacionEstatus === 'SOLVENTADA') {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss">

</style>
